export default __webpack_public_path__ + "static/media/icon-campaignmanagement-outline.c2429c3b.svg";